export const FieldType = {
  Behaviour: 'Behaviour',
  Verbatim: 'Verbatim',
};
